import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import {
  MixedWidget1,
  ListsWidget9,
  StatsWidget1,
  StatsWidget11,
  StatsWidget12,
  // AdvanceTablesWidget2,
} from "../widgets";
import StatisticsChart from "../widgets/mixed/StatisticChart";
import { PendingActions } from "../widgets/lists/PendingActions/PendingActions";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import {
  setDashboardSelectedCurrency,
  getDashboardCampaignsRevenues,
  getDashboardCampaignTotalInvestment,
  getDashboardCampaignTotalRepayment,
} from "../../../store/actions/dashboard/dashboardActions";
import * as actions from "../../../store/actions/index";
import "./Dashboard.scss";
import { CurrencyLogo } from "../../../helpers/CryptoCurrencySymbol";

export function Demo1Dashboard() {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(true);
  const taxonomy = useSelector((state) => state?.taxonomy?.taxonomy);
  const siteSetting = useSelector((state) => state.settings.generalSettings);
  const { activeCurrency } = useSelector((state) => state.misc);
  const { dashboardSelectedCurrency } = useSelector((state) => state.dashboard);
  const { currentPermissions } = useSelector((state) => state.role);
  const currencyRef = useRef(null);

  useEffect(() => {
    dispatch(actions.getMeta());
    dispatch(actions.getGeneralSettings());
  }, [dispatch]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsVisible(false);
    }, 5500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isVisible]);

  const changeCurrencyHandler = (currencyId) => {
    dispatch(setDashboardSelectedCurrency(currencyId));
    dispatch(getDashboardCampaignsRevenues(currencyId));
    dispatch(getDashboardCampaignTotalInvestment(currencyId));
    dispatch(getDashboardCampaignTotalRepayment(currencyId));
    setIsVisible(true);
  };

  useLayoutEffect(() => {
    const activeBtn = currencyRef.current?.querySelector(
      ".currency-toggle-btn--active"
    );

    if (activeBtn && currencyRef.current) {
      const { offsetLeft, offsetWidth } = activeBtn;

      currencyRef.current.style.setProperty("--glider-left", `${offsetLeft}px`);
      currencyRef.current.style.setProperty(
        "--glider-width",
        `${offsetWidth}px`
      );
    }
  }, [dashboardSelectedCurrency, activeCurrency]);

  return (
    <section className="position-relative d-flex flex-column gap-5">
      <div
        ref={currencyRef}
        className="currency-toggle end-0 ms-auto d-flex bg-white p-1">
        <span className="currency-toggle-glider" />

        {activeCurrency?.doc?.map((currency, index) => {
          const isActive = dashboardSelectedCurrency === currency?._id;
          const showLoading = isActive && isVisible;
          return (
            <Button
              key={index}
              disabled={isVisible}
              onClick={() => changeCurrencyHandler(currency?._id)}
              className={`currency-toggle-btn border-0 py-1 ${
                isActive ? "currency-toggle-btn--active" : ""
              }`}
              style={{
                fontWeight: "bold",
                borderRadius: "10px",
                fontSize: "14px",
                color: isActive ? "white" : "black",
                backgroundColor: "transparent",
                zIndex: 2,
              }}>
              {showLoading ? (
                <span
                  className="spinner-border spinner-border-sm currency-toggle-spinner"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <>
                  <span className="d-flex me-1">
                    {siteSetting?.paymentMethod !== "crypto-payment" ? (
                      currency?.symbol
                    ) : (
                      <CurrencyLogo
                        symbol={currency?.symbol}
                        variant="dark"
                        className={`mb-0 ${
                          isActive ? "img-filter-invert" : ""
                        }`}
                        height={16}
                      />
                    )}
                  </span>
                  {currency?.code}
                </>
              )}
            </Button>
          );
        })}
      </div>

      <div className="col-xxl-12 mt-14 mt-lg-3">
        <StatsWidget1 className="gutter-b" taxonomy={taxonomy} />
      </div>

      <div className="row">
        {/* <div className="col-lg-12 col-xxl-4">
          <MixedWidget1 className="card-stretch gutter-b" />
        </div>

        <div className="col-lg-6 col-xxl-4">
          <StatsWidget11 className="card-stretch gutter-b" />
        </div>

        <div className="col-lg-6 col-xxl-4 order-1 order-xxl-1">
          <StatsWidget12 className="card-stretch gutter-b" />
        </div> */}

        {/* <div className="col-xxl-12 order-2 order-xxl-1">
          <AdvanceTablesWidget2
            className="card-stretch gutter-b"
            taxonomy={taxonomy}
          />
        </div> */}

        {currentPermissions?.view_pending_actions && (
          <div className="col-xl-6 order-2 order-xxl-1 mb-4 mb-xl-0">
            {/* pending actions new component  */}
            <PendingActions className="card-stretch gutter-b rounded-fix" />
          </div>
        )}

        {currentPermissions?.view_recent_activities && (
          <div className="col-xl-6 order-2 order-xxl-1">
            <ListsWidget9 className="card-stretch gutter-b rounded-fix" />
          </div>
        )}
      </div>
      {currentPermissions?.view_statistics && (
        <div className="col-lg-12">
          <StatisticsChart
            dashboardSelectedCurrency={dashboardSelectedCurrency}
          />
        </div>
      )}
    </section>
  );
}
